import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import axiosInstance from "../utils/api/axiosInstance"; // Unified axios config

// 🔹 Create Category Context
const CategoryContext = createContext();

// 🔹 Hook to access category context
export const useCategories = () => useContext(CategoryContext);

// 🔹 Provider Component
export const CategoryProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // 🔹 Fetch all categories
  const fetchCategories = useCallback(async (activeOnly = true) => {
    try {
      setLoading(true);
      const query = activeOnly ? "?activeOnly=true" : "";
      const res = await axiosInstance.get(`/categories${query}`);
      setCategories(res.data);
      setError(null);
    } catch (err) {
      console.error(
        "❌ Failed to fetch categories:",
        err.response?.data || err.message,
      );
      setError(err.response?.data || "Failed to fetch categories");
    } finally {
      setLoading(false);
    }
  }, []);

  // 🔹 Load active categories on mount
  useEffect(() => {
    fetchCategories(true);
  }, []);

  return (
    <CategoryContext.Provider
      value={{ categories, fetchCategories, loading, error }}
    >
      {children}
    </CategoryContext.Provider>
  );
};
